import { css } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { desktop } from '../utils';

export const styles = css`
  :host {
    contain: strict;
  }

  .overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.1s ease-in, visibility 0.1s linear;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .overlay.no-scroll {
    overflow: hidden;
  }

  :host([notransition]) .overlay {
    transition: none;
  }

  .header-wrap {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1;
    align-items: center;
    width: 100%;
    flex: none;
    background-color: #fff;
  }

  @supports not ((position: sticky) or (position: -webkit-sticky)) {
    .header-wrap {
      position: absolute;
    }

    .content {
      padding-top: ${pxToRem(62)};
    }

    ${desktop(css`
      .content {
        padding-top: ${pxToRem(82)};
      }
    `)}
  }

  .container {
    min-height: 100%;
  }

  .scroll-compensator {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: calc(100vw - var(--scrollbar-width, 0));
  }

  .content {
    display: flex;
    flex: 1 1 100%;
    min-height: 100%;
    flex-direction: column;
  }

  .overlay.show {
    visibility: visible;
    opacity: 1;
  }

  .close {
    --button-color: var(--close-button-color);

    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .close-inner {
    margin: 0 -${pxToRem(8)};
    padding: ${pxToRem(8)};
  }

  :host([withoutheader]) .overlay {
    box-shadow: none;
  }

  :host([dark]) .overlay {
    background-color: rgb(68, 75, 91, 0.6);
  }
`;
